import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=11cbd66c&scoped=true"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"
import style0 from "./employees.vue?vue&type=style&index=0&id=11cbd66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbd66c",
  null
  
)

export default component.exports